// src/utils/auth.js
export const getAuthData = () => {
  try {
    const token = localStorage.getItem('authToken');
    const userId = localStorage.getItem('userId');
    const userRole = localStorage.getItem('userRole');
    const institutionId = localStorage.getItem('institutionId');
    
    if (!token) {
      return null;
    }
    
    return {
      token,
      userId: userId ? parseInt(userId, 10) : null,
      userRole,
      institutionId: institutionId ? parseInt(institutionId, 10) : null
    };
  } catch (error) {
    console.error('Error getting auth data:', error);
    return null;
  }
};

export const setAuthData = (data) => {
  try {
    if (data.token) {
      localStorage.setItem('authToken', data.token);
    }
    if (data.userId) {
      localStorage.setItem('userId', data.userId.toString());
    }
    if (data.userRole) {
      localStorage.setItem('userRole', data.userRole);
    }
    if (data.institutionId) {
      localStorage.setItem('institutionId', data.institutionId.toString());
    }
  } catch (error) {
    console.error('Error setting auth data:', error);
  }
};

export const clearAuthData = () => {
  try {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('institutionId');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('institutionName');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
  } catch (error) {
    console.error('Error clearing auth data:', error);
  }
};

export const isAuthenticated = () => {
  const authData = getAuthData();
  return !!(authData && authData.token);
};

export const getUserRole = () => {
  const authData = getAuthData();
  return authData ? authData.userRole : null;
};

export const getUserId = () => {
  const authData = getAuthData();
  return authData ? authData.userId : null;
};

export const getToken = () => {
  const authData = getAuthData();
  return authData ? authData.token : null;
};